import { useQuery } from '@tanstack/react-query';
import { AlertApi } from '../../../apis/AlertApi/AlertApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IAlertDetail } from '../Alert';

export function useAlertDetail(id: number | undefined) {
    return useQuery<IAlertDetail>({
        queryKey: [QueryKeys.alertDetail, id],
        queryFn: () => AlertApi.getAlertDetail(id!),
        enabled: !!id,
    });
}
